import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Panel } from '../../../../../../../common/panel'
import { selectTypePeriod } from '../../../../../store/slice'

import CorporateLinkageScoreTable from './CorporateLinkageScoreTable'
import { selectIdsTable } from './store/slice'
import { downloadLinkageScore, getLinkageScoreThunk } from './store/thunk'

export const TABLE_COL = {
  CHECKBOX: 'CHECKBOX',
  PROFILE_NAME: 'profileName',
  PORTFOLIO: 'numberOfPortfolios',
  ENABLE_EMAIL: 'enableEmail',
  TOOLS: 'TOOLS',
}

const CorporateLinkageScore = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const locale = useSelector((state) => state.i18n.locale)
  const timeFrequency = useSelector(selectTypePeriod)
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const ids = useSelector(selectIdsTable)

  useEffect(() => {
    dispatch(
      getLinkageScoreThunk({
        OrganizationId: params.organizationId,
      }),
    )
  }, [locale])

  return (
    <Panel
      isI18n
      label="corporateLinkageScore.title"
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () =>
          downloadLinkageScore({
            OrganizationId: params.organizationId,
            TimeFrequency: timeFrequency,
          }),
      }}
    >
      <CorporateLinkageScoreTable />
    </Panel>
  )
}

export default CorporateLinkageScore
